import { connect } from 'react-redux';
import { sendGAEvent, sendGALinkClickEvent } from '@noths/polaris-client-google-analytics';

import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import {
  selectAreRequiredPersonalisationsIncomplete,
  selectIsSubmitPersonalisationFormPending,
  selectPersonalisationFromBasket,
} from 'src/redux/personalisation/selectors';
import { submitPersonalisationForm } from 'src/redux/personalisation/thunks/submitPersonalisationForm';
import { selectPersonalisationOptions, selectProduct } from 'src/redux/product/selectors';
import type { AppThunkDispatch } from 'src/redux/store';
import type { BasketCTAButtonDispatchProps, BasketCTAButtonStateProps } from './BasketCTAButton';
import { BasketCTAButton } from './BasketCTAButton';
import { MAIN_PAGE_CTA_ID } from './elementIDs';

const mapStateToProps = (state: ReduxApplicationState): BasketCTAButtonStateProps => {
  return {
    editMode: Boolean(selectPersonalisationFromBasket(state)),
    hasOptions: selectPersonalisationOptions(state).length > 0,
    loading: selectIsSubmitPersonalisationFormPending(state),
    personalisable: selectProduct(state).specialFeatures.personalisable,
    purchasable: selectProduct(state).purchasable,
    requiredFieldsIncomplete: selectAreRequiredPersonalisationsIncomplete(state),
  };
};

const mapDispatchToProps = (dispatch: AppThunkDispatch): BasketCTAButtonDispatchProps => {
  return {
    onAddEditClick: () => dispatch(submitPersonalisationForm()),
    onBuyGiftCard: (ev: React.MouseEvent) => {
      sendGALinkClickEvent(ev, {
        event: 'custom_event',
        event_action: 'Buy giftcard',
        event_category: 'Product page',
        event_label: 'not set',
      });
    },
    onVisible: () => {
      const ctaButton: HTMLElement | null = document.getElementById(MAIN_PAGE_CTA_ID);

      sendGAEvent({
        event: 'custom_event',
        event_category: 'Product page CTA',
        event_action: 'Impression',
        event_label: ctaButton?.textContent ?? '',
      });
    },
  };
};

export const BasketCTAButtonContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(BasketCTAButton);
